export function setDirectionScheme(language) {
  switch (language) {
    case 'ar':
      document.documentElement.style.setProperty('--right-alignment', 'right');
      document.documentElement.style.setProperty('--direction', 'rtl');
      break;
    case 'uae':
      document.documentElement.style.setProperty('--right-alignment', 'right');
      document.documentElement.style.setProperty('--direction', 'rtl');
      break;
    default:
      document.documentElement.style.setProperty('--right-alignment', 'unset');
      document.documentElement.style.setProperty('--direction', 'unset');
  }
}
